import React from 'react';
import { motion } from 'framer-motion';
const galleryItems = [{
  id: 1,
  type: 'video',
  src: 'https://cdn.magicpatterns.com/uploads/7KYzRN2ATVhmZp4PxwjA2j/From Main Klickpin CF- Pinterest Video - 3uDrOoGah.mp4',
  caption: 'Proceso de creación: Nombres'
}, {
  id: 2,
  type: 'video',
  src: 'https://cdn.magicpatterns.com/uploads/gvn2ox7PdRTixG7s9nypaM/From Main Klickpin CF- Pinterest Video - 2r2JpQ01E.mp4',
  caption: 'Flores decorativas paso a paso'
}, {
  id: 3,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/bZCZvaHsPUYZP9x8PPBFym/Nombres_con_alambre_tejido.jpg',
  caption: 'Nombres con alambre tejido'
}, {
  id: 4,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/oipUiVxVqBVkomLyp5kcdL/descarga.jpg',
  caption: 'Nombres personalizados con flores'
}, {
  id: 5,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/tpz5H2Ti1tMKk7JUFeeta9/Porta_maternidade_violeta.jpg',
  caption: 'Porta maternidad en bastidor'
}, {
  id: 6,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/jJVYpMJcENe6qp8TP95MSa/стич_трикотин_ночник_стич.jpg',
  caption: 'Lámpara decorativa de personaje'
}];
export function GallerySection() {
  return <section className="py-20 bg-cream" data-id="element-42">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
        <div className="text-center mb-16" data-id="element-44">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif font-bold text-dark" data-id="element-45">
            Mira lo que puedes crear
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="mt-4 text-lg text-muted" data-id="element-46">
            Proyectos reales hechos en casa
          </motion.p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-47">
          {galleryItems.map((item, index) => <motion.div key={item.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 group border border-gray-50" data-id="element-48">
              <div className="relative h-80 overflow-hidden bg-cream" data-id="element-49">
                {item.type === 'video' ? <video src={item.src} autoPlay loop muted playsInline className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-50" /> : <img src={item.src} alt={item.caption} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-51" />}
                {item.type === 'video' && <div className="absolute top-4 right-4 bg-dark/50 backdrop-blur-sm px-2 py-1 rounded text-white text-xs font-bold tracking-wider" data-id="element-52">
                    VIDEO
                  </div>}
              </div>
              <div className="p-5 text-center bg-white relative z-10" data-id="element-53">
                <p className="font-medium text-dark" data-id="element-54">{item.caption}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}